import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const allTicketsRBAC = {
  pageID: 'ec83c5a542af5e3745658391b66022b5',
  elementID: {
    ViewPage: '2af7eba43a41b4008230d7328cf5b42f',
    FilterSemuaTim: '91cafedf78896b01d7e7da6757030e21',
    StatusBaruBatalkanTiket: 'befa335c93dd15e7a0e06135b96b7aeb',
    StatusMenungguPindahTim: '7401ae024fd9f0669ca2eb4db01d7d4e',
    StatusMenungguBatalkanTiket: 'faec20ee73153b059d6d6d37f9cc92ef',
    StatusMenungguAcknowledge: 'fc4357705a2e5063fe214d0f835a8210',
    StatusDiterimaPindahTim: 'b9313444adb1e77690976a111b6d0445',
    StatusDiterimaBatalkanTiket: '80f5b240161c2ab14e13b5d6d5484274',
    StatusDiterimaMulaiDikerjakan: 'a251d576e8b026f7e1932f7a49a7e447',
    StatusSedangDikerjakanBatalkanTiket: 'd45b2127908eb831d97d97447a2f35ff',
    StatusSedangDikerjakanSelesaikan: '810ad709a3db415983addd2a9eed87b4',
    StatusSelesaiTutupTiket: 'b05559708ccd7a7b9ff1475c3f8b97d1',
  },
} as const

export const useRBACAllTicketsPage = createUseRBAC(allTicketsRBAC.elementID)
export type UseRBACAllTicketsPageType = ReturnType<typeof useRBACAllTicketsPage>
